import { AbstractGameView } from "@lib/titan2-slingo/dist/game/view/abstract/display/AbstractGameView";
import { ApiConstants } from "../../../../../model/enum/ApiConstants";
import { GameLang } from "../../../lang/GameLang";
import { PayTableCellStates } from "../PayTableCellStates";
import { PayTableSpineRegister } from "../PayTableSpineRegister";
import { PayTableCellStatePair } from "./PayTableCellStatePair";
export class GamePayTableCell extends AbstractGameView {
    constructor(factory, landscapeProperties, portraitProperties, index) {
        super(factory, landscapeProperties, portraitProperties);
        this.landscapeProperties = landscapeProperties;
        this.portraitProperties = portraitProperties;
        this.states = new Map();
        this.currentState = 'UNREACHED';
        const stackedFullHouse = [
            this.langManager.getLang(GameLang.FULL_HOUSE_0),
            this.langManager.getLang(GameLang.FULL_HOUSE_1),
        ].join("\n");
        PayTableCellStates.forEach(state => {
            const statePair = new PayTableCellStatePair(landscapeProperties.cellStates[state], portraitProperties?.cellStates[state]);
            this.states.set(state, statePair);
            if (index + 1 === ApiConstants.CELL_COUNT) {
                statePair.setLabel(stackedFullHouse);
            }
            else {
                const labelString = this.langManager.getLang(GameLang[`SLINGO_${this.cellToNumberOfPatterns(index)}`]);
                statePair.setLabel(labelString);
            }
            statePair.toggleVisible(state === this.currentState);
        });
    }
    slotInSpine(spine, index) {
        this.states.forEach((cellState, state) => {
            cellState.slotInSpine(spine, PayTableSpineRegister.getLabelSlotForState(state, index), PayTableSpineRegister.getValueSlotForState(state, index));
        });
    }
    setValue(value) {
        this.states.forEach(cellState => cellState.setValue(value));
    }
    cellToNumberOfPatterns(cellIndex) {
        return cellIndex + 1;
    }
    setState(state, animate = false) {
        this.states.forEach((value, key) => {
            value.toggleVisible(key === state, animate);
        });
        this.currentState = state;
    }
    showAvailableWin() {
        this.states.forEach((value, key) => {
            value.toggleVisible(key === "AVAILABLE_WIN");
        });
    }
    clearAvailableWin() {
        this.states.forEach((value, key) => {
            value.toggleVisible(key === this.currentState);
        });
    }
    getFontSize() {
        return this.states.get("UNREACHED")?.getValueElement()?.getPixiText()?.style?.fontSize ?? 1;
    }
    updateFontStyle(targetSize) {
        this.states.forEach(cell => {
            const text = cell.getValueElement();
            const label = cell.getLabelElement();
            const updateStyle = (target) => {
                const originalStyle = target.getDefaultTextStyle();
                originalStyle.strokeThickness = originalStyle.strokeThickness * targetSize / originalStyle.fontSize; //adjust stroke with size
                originalStyle.fontSize = targetSize;
                target.setText(target.getText(), true); //to apply the change
            };
            updateStyle(text);
            updateStyle(label);
        });
    }
}
//# sourceMappingURL=GamePayTableCell.js.map